import { useEffect, useState } from "react";

import { getDefaultIpCountry, resolveIpCountryDefault } from "../Utils/IpCountry";

export default function useIpCountryDefault() {
  const [ipCountry, setIpCountry] = useState(() => getDefaultIpCountry());

  useEffect(() => {
    let isMounted = true;

    resolveIpCountryDefault().then((resolvedCountry) => {
      if (isMounted) setIpCountry(resolvedCountry);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return ipCountry;
}

